export const filterDataObject = {
  OrderNumber: "",
  ShipmentNumber: "",
  Incoterm: "",
  OrderStatus: "",
  OrderFromDate: "",
  OrderToDate: "",
  Container: "",
  BuyerCode: "",
  BuyerName: "",
  SupplierCode: "",
  SupplierName: "",
  ContainerMode: "",
  TransportMode: "",
  Vessel: "",
  Voyage: "",
  CarrierCode: "",
  OPortCode: "",
  OPortName: "",
  DPortCode: "",
  DPortName: "",
  SAgentCode: "",
  SAgentName: "",
  RAgentCode: "",
  RAgentName: "",
  ETDFromDate: "",
  ETDToDate: "",
  ETAFromDate: "",
  ETATDate: "",
  CutOffFromDate: "",
  CutOffToDate: "",
  OrderMblNumber: ""
};
